import { AuthService } from '@mogenius/user/services/auth/auth.service';
import { ClusterSocketEventService } from '@mogenius/cluster/services/cluster-socket-event.service';
import { WorkspaceSocketEventService } from '@mogenius/workspace/services/workspace-socket-event.service';
import { Observable, switchMap, tap } from 'rxjs';
import { inject } from '@angular/core';
import { DesignModeService } from '@mogenius/shared/services/design-mode/design-mode.service';
import { MetaService } from '@mogenius/core/services/meta.service';
import { AiInsightsSocketEventService } from '@mogenius/ai-insights/services/ai-insights-socket-event.service';

export function appProviderFactory(): Observable<any> {
  const authService = inject(AuthService);
  const clusterSocketEventService = inject(ClusterSocketEventService);
  const aiInsightsSocketEventService = inject(AiInsightsSocketEventService);
  const workspaceSocketEventService = inject(WorkspaceSocketEventService);
  const designModeService = inject(DesignModeService);
  const metaService = inject(MetaService);

  return metaService.initialize().pipe(
    switchMap(() =>
      authService.initialize().pipe(
        tap(() => {
          clusterSocketEventService.initialize();
          aiInsightsSocketEventService.initialize();
          workspaceSocketEventService.initialize();
          designModeService.init();
        })
      )
    )
  );
}
